import { Stack, StackProps, styled } from '@mui/material';

import { generateClasses } from '../../../utils/helper';

export const tileCoursesFormClasses = generateClasses('ActivityCoursesForm', ['courseList']);

export const Content = styled((props: StackProps) => <Stack flex={1} gap={2} {...props} />)(({ theme }) => ({
  overflow: 'hidden',
  color: theme.palette.common.black,
  [`& .${tileCoursesFormClasses.courseList}`]: {
    overflow: 'auto',
    flex: 1,
  },
}));
